<template>
  <v-container
    id="container-wrap"
    fluid
    pa-0
    v-show="isAuthorized && isShow"
  >
    <pdf-header
      :disabled-finish="finishButtonDisabled"
      :signed-pdf="signedPdf"
      :company-logo="companyLogo"
      :document-name="documentName"
      :token="token"
      :signed-pdf-list="signedPdfList"
      :environment="environment"
      :signee-order-type="signeeOrderType"
      ref="signPDFHeader"
      :module-id="this.moduleId == this.moduleIdTimesheet || this.moduleId == this.moduleIdExpense || this.moduleId == this.moduleIdPO ? moduleId : null"
    />
    <pdf-agreement-dialog
      ref="pdfAgreementDialog"
      :document-name="fileName"
      :signee-name="signeeName"
      :company-logo="companyLogo"
      :company="company"
      :token="token"
    />
    <!-- Actions Bar -->
    <v-row
      class="action-bar"
      style="max-height: 70px !important; min-height: 70px !important;"
    >
      <v-col
        md="1"
        lg="1"
        xl="1"
        sm="auto"
        xs="auto"
      />
      <v-col
        cols="auto"
        class="pr-0 pl-0"
      >
        <v-btn
          color="primary"
          outlined
          @click="handleDownload"
        >
          Download
        </v-btn>
      </v-col>
      <v-col
        cols="auto"
        class="pr-0 pl-3"
      >
        <v-btn
          color="primary"
          outlined
          @click="redirect(moduleId)"
        >
          Back to {{ getModuleName() }}
        </v-btn>
      </v-col>
      <v-spacer />
      <v-col
        cols="auto"
        class="pt-2"
      >
        <pdf-navigation
          :page="page"
          :pages-count="pagesCount"
          @increment="page++"
          @decrement="page--"
        />
      </v-col>
      <v-spacer />
      <v-col
        cols="auto"
        style="width: 250px !important;"
        class=""
        v-if="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm'"
      >
        <v-btn
          class="TierButton pb-0 text-center ml-1"
          icon
          @click="setPdfZoom(currentZoom - 0.2)"
        >
          <v-icon style="color: black;">
            mdi-magnify-minus-outline
          </v-icon>
        </v-btn>
        <v-btn
          class="TierButton pb-0 text-center ml-1"
          outlined
          width="110"
          height="30"
          @click="resetPdfZoom()"
        >
          RESET ZOOM
        </v-btn>
        <v-btn
          class="TierButton pb-0 text-center"
          icon
          @click="setPdfZoom(currentZoom + 0.2)"
        >
          <v-icon style="color: black;">
            mdi-magnify-plus-outline
          </v-icon>
        </v-btn>
      </v-col>
      <v-col
        md="1"
        lg="1"
        xl="1"
        sm="auto"
        xs="auto"
      />
    </v-row>
    <v-row
      no-gutters
      class="content-pdf"
      ref="contentWrapper"
    >
      <v-col
        cols="2"
        style="padding-right: 4vw; padding-top: 8vh;"
      >
        <v-data-table
          :items="documentList"
          :hide-default-header="true"
          :hide-default-footer="true"
          style="z-index: 100; position: absolute;"
        >
          <template v-slot:item="{ item }">
            <tr
              :style="{
                background: item.id == currentDocument ? 'lightgreen' : 'white',
                color: 'black',
              }"
              class="text-left"
            >
              <td
                style="font-size: 18px;"
                @click="changeCurrentDocument(item)"
              >
                {{ item.originalName }}
              </td>
            </tr>
          </template>
        </v-data-table>
        <v-row>
          <v-spacer />
          <v-col
            class="pr-12 pl-0"
            cols="auto"
            style="min-width: 110px;"
          >
            <v-btn
              v-if="finishButtonDisabled && isUsePermanetSignature && (this.moduleId == this.moduleIdTimesheet || this.moduleId == this.moduleIdExpense || this.moduleId == this.moduleIdPO)"
              color="green"
              fixed
              :style="{ 'z-index': 100, 'margin-top': nextButtonMarginTop + '%' }"
              @click="getWorkerSignature(token, false, false, true); handleNext();"
            >
              <span style="color: #FFFFFF">Sign All</span>
            </v-btn>
          </v-col>
          <v-col
            cols="auto"
            class="pr-0"
          >
            <v-btn
              v-if="finishButtonDisabled"
              color="#F0D549"
              fixed
              :style="{ 'z-index': 100, 'margin-top': nextButtonMarginTop + '%' }"
              @click="handleNext()"
            >
              Next
            </v-btn>
          </v-col>
        </v-row>
      </v-col>

      <v-col
        cols="10"
        lg="8"
      >
        <!-- Sign Modals -->
        <v-dialog
          v-model="showSignatureModal"
          max-width="550px"
          persistent
        >
          <v-card>
            <v-card-title class="pb-3">
              <v-row>
                <v-col cols="auto">
                  <span style="font-weight: bold; font-size: 26px; color: #000000;">Choose Sign Type</span>
                </v-col>
                <v-col class="text-end pt-0">
                  <v-btn
                    icon
                    @click="showSignatureModal = false"
                    color="#000000"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-spacer />
                <v-col>
                  <v-btn
                    color="primary"
                    outlined
                    :disabled="(moduleId === moduleIdExpense || moduleId === moduleIdPO || moduleId === moduleIdTimesheet) && (!isAgreed)"
                    @click="
                      showSignatureModal = false;
                      handleSignDrawing();
                    "
                  >
                    Sign By Drawing
                  </v-btn>
                </v-col>
                <v-col>
                  <v-btn
                    color="primary"
                    :disabled="(moduleId === moduleIdExpense || moduleId === moduleIdPO || moduleId === moduleIdTimesheet) && (!isAgreed)"
                    @click="
                      showSignatureModal = false;
                      handleSignTyping();
                    "
                  >
                    Sign By Typing
                  </v-btn>
                </v-col>
                <v-spacer />
              </v-row>
              <v-row v-if="moduleId === moduleIdExpense || moduleId === moduleIdPO || moduleId === moduleIdTimesheet">
                <v-col
                  cols="auto"
                  class="pt-0 pr-0"
                >
                  <v-checkbox
                    v-model="isAgreed"
                    hide-details
                  />
                </v-col>
                <v-col class="pt-5 pl-1">
                  <span style="font-size: 16px; color: #000000;">By creating one time signature you acknowledge and agree to our </span>
                  <a
                    style="font-size: 16px;"
                    @click="openSignatureDisclosure"
                  >Electonic Record and Signature Disclosure</a>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions
              class="pa-6"
              style="background-color: #F5F5F5; border-top: 1px solid #D7D7D7;"
              v-if="moduleId === moduleIdExpense || moduleId === moduleIdPO || moduleId === moduleIdTimesheet"
            >
              <span>It appears that you haven't yet created your permanent electronic signature. Create one in your <a
                :href="redirectProfileLink()"
                target="_blank"
              >User Profile</a></span> 
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="showDateModal"
          :width="415"
        >
          <v-card>
            <v-card-text class="text-center pt-5 pb-0">
              <v-date-picker
                v-model="signingDate"
                no-title
                scrollable
              />
            </v-card-text>
            <v-card-actions>
              <v-row class="mx-0 align-center">
                <v-spacer />
                <v-col class="text-right">
                  <a
                    class="mx-5"
                    @click="showDateModal = false"
                  >Cancel </a>
                </v-col>
                <v-col
                  class="shrink"
                >
                  <v-btn
                    color="success"
                    @click="
                      showDateModal = false;
                      handleSignDate();
                    "
                  >
                    Ok
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="showSignaturePad"
          :width="640"
        >
          <v-card>
            <v-card-title class="headline grey lighten-2">
              <v-row>
                <v-col cols="auto">
                  <span>Please sign in the box below</span>
                </v-col>
                <v-col class="text-end">
                  <v-btn
                    icon
                    @click="showSignaturePad = false;
                            showSignatureModal = true;"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <canvas
                ref="signature"
                width="600"
                height="200"
              />
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                @click="signaturePad.clear()"
                outlined
              >
                reset
              </v-btn>
              <v-btn
                class="white--text"
                color="green"
                :disabled="signaturePad && signaturePad.isEmpty()"
                @click="handleSignDrawingSubmit"
              >
                sign
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <span id="fontLoader" />
        <v-card
          class="mx-auto elevation-0"
          :loading="isLoading"
        >
          <!-- PDF Viewer -->
          <canvas
            class="sx-absolute-centered"
            :class="hovering !== -1 && 'clickable'"
            :style="{ zIndex: 2 }"
            ref="overlay"
            @mousemove="mousemove"
            @click="handleOverlayClick"
          />
          <canvas
            ref="canvas"
            class="sx-absolute-centered"
            :style="{ zIndex: 1 }"
          />
        </v-card>
      </v-col>
      <v-spacer />
    </v-row>

    <pdf-footer />
    <prompt-dialog
      v-show="false"
      ref="promptDialog"
    />
    <create-personal-signature-form
      v-show="false"
      ref="createPersonalSignatureForm"
      :environment="environment"
    />
    <personal-signature-form
      v-show="false"
      ref="personalSignatureForm"
      :environment="environment"
      :token="token"
    />
    <signature-disclosure-dialog
      ref="signatureDisclosureDialog"
      :company="company"
    />
  </v-container>
</template>

<script>
import SignaturePad from 'signature_pad';
import { rgb } from 'pdf-lib';
//import download from 'downloadjs';
import pdf from '@/mixins/pdf';
import hover from '@/mixins/hover';
import PdfNavigation from '@/components/SignPdf/PdfNavigation';
import dayjs from 'dayjs';
import PdfHeader from '@/components/SignPdf/Sign/PdfHeader.vue';
import PdfFooter from '@/components/SignPdf/Sign/PdfFooter.vue';
import PdfAgreementDialog from '@/components/SignPdf/Sign/PdfAgreementDialog.vue';
import Bus from '@/bus';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import PromptDialog from '@/components/PromptDialog.vue';
import CreatePersonalSignatureForm from '@/components/SignPdf/CreatePersonalSignatureForm.vue';
import PersonalSignatureForm from '@/components/SignPdf/PersonalSignatureForm.vue';
import SignatureDisclosureDialog from '@/components/SignPdf/Sign/SignatureDisclosureDialog.vue';


export default {
  components: { PdfNavigation, PdfHeader, PdfFooter, PdfAgreementDialog, PromptDialog, CreatePersonalSignatureForm, PersonalSignatureForm, SignatureDisclosureDialog },
  mixins: [pdf, hover],
  data() {
    return {
      showDateModal: false,
      showSignatureModal: false,
      showSignaturePad: false,
      signaturePad: null,
      signaturePadState: [null, null],
      signaturePadStateIdSignature: 0,
      signaturePadStateIdInitials: 1,
      hovering: -1,
      signing: -1,
      mouse: {
        x: -1,
        y: -1,
      },
      signingDate: dayjs().format('YYYY-MM-DD'),
      isLoading: true,
      datepickerMenu: false,
      isAuthorized: false,
      isShow: false,
      file: '',
      companyLogo: '',
      elements: [],
      documentName: '',
      token: '',
      environment: '',
      signeeName: '',
      fileName: '',
      company: { name: '', email: '' },
      pdfInfo: [],
      documentList: [],
      currentDocument: null,
      packageName: '',
      activeDocument: null,
      signingElement: -1,
      signingPlacement: -1,
      finishButtonDisabled: true,
      betterFont: 'BetterGrade',
      signedPlacements: [],
      signedList: [],
      elementsList: [],
      nextButtonMarginTop: 0,
      originalDocumentsList: [],
      signeeOrderType: 1,
      isInitials: false,
      lastElementLabels: [],
      currentZoom: 1,
      moduleId: null,
      moduleRecordId: null,
      moduleIdExpense: 2,
      moduleIdTimesheet: 6,
      moduleIdPO: 12,
      signedByName: null,
      signedByWorkerId: null,
      signatureBlob: null,
      initialsBlob: null,
      roleOrder: null,
      isUsePermanetSignature: false,
      createdByManagerId: null,
      isAgreed: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    var token;
    var environment;
    if (to.query && to.query.token && to.query.environment) {
      token = to.query.token;
      environment = to.query.environment;
      next((vm) => {
        vm.init(token, environment);
      });
    } else {
      alert('Error: Opening PDF');
    }
  },
  watch: {
    signingPlacement() {
      this.signedList.forEach((s) => {
        if (s.documentId === this.currentDocument) s.signed = this.signed;
      });
      this.elementsList.forEach((el) => {
        if (el.documentId === this.currentDocument) el.elements = this.elements;
      });

      this.finishButtonDisabled = this.countPlacementKeys();
    },
    activeDocument() {
      this.finishButtonDisabled = this.countPlacementKeys();
    },
    signedPdf() {
      this.signedPdfList.forEach((p) => {
        if (p.documentId === this.currentDocument) p.pdf = this.signedPdf;
      });
    },
  },
  mounted() {
    this.isLoading = false;
  },
  methods: {
    async init(token, environment) {
      Bus.$on('submitEnvelopePlacements', async (resolve, reject) => {
        let res = await this.submitEnvelopePlacements();
        res == true ? resolve(res) : reject(res);
      });
      this.environment = environment;
      var isAuthorized = await this.authorize(token);
      if (isAuthorized) {
        await this.getDocuments(token);
        const documentDataRes = await this.getDocumentData(token);
        if(!documentDataRes){
          return;
        }
        this.getFonts();
        this.token = token;
        this.downloadCompanyLogo(token);
        this.isAuthorized = true;
        this.isShow = true;
        if(this.moduleId !== this.moduleIdTimesheet && this.moduleId !== this.moduleIdExpense && this.moduleId !== this.moduleIdPO){
          this.$refs.pdfAgreementDialog.open().then((resolve) => {
            if (!resolve) {
              window.location.replace('https://www.systemx.net');
            }
          });
        }
        else
        {
          this.getWorkerSignature(this.token, false);
        }
      }
    },
    async authorize(token) {
      try {
        this.$api.setSxEnvironment(this.environment);

        const data = { Token: token };
        const res = await this.$api.post(`sign-pdf/envelopes/authorize`, data);
        this.isLoading = false;
        if (res.status === 200) {
          this.isError = false;
          return true;
        }
      } catch (error) {
        this.file = '';
        this.isLoading = false;

        let errorMessage = error;
        let errorCode = error;
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          if (error.response.data.message) {
            errorCode = error.response.data.message;
            if(errorCode.includes('1002'))
            {
              var environment = this.environment;
              this.$router.push({
                path: '/sign-pdf/view',
                query: { environment, token },
              });
              return false;
            }
            switch (errorCode) {
              case '1000':
                errorMessage = 'Error: Document envelope not found.';
                break;
              case '1003':
                errorMessage = 'Error: Document cancelled by creator.';
                break;
              case '1004':
                errorMessage = 'Error: Document declined by signee.';
                break;
              case '1005':
                errorMessage = 'Error: Document no longer available.';
                break;
              case '1006':
                errorMessage = 'Error: Document expired.';
                break;
              default:
                break;
            }
          }
        }
        else if (errorCode.includes('1002')) {
          var environment = this.environment;
          this.$router.push({
            path: '/sign-pdf/view',
            query: { environment, token },
          });
          return false;
        }
        this.isError = true;
        this.message = errorMessage;
        Bus.$emit('alert', 'error', this.message);
        return false;
      }
    },
    setPdfZoom(incomingZoom)
    {
      this.currentZoom = incomingZoom
      this.setZoom(this.currentZoom)
    },
    resetPdfZoom()
    {
      this.currentZoom = 1
      this.setZoom(this.currentZoom)
    },
    async getDocuments(token) {
      try {
        this.$api.setSxEnvironment(this.environment);
        const data = { Token: token };
        const response = await this.$api.post(
          `sign-pdf/envelopes/get-documents`,
          data
        );
        const downloadDocumentsResponse = await this.$api.post(
          `sign-pdf/envelopes/download-file`,
          data
        );
        this.originalDocumentsList = downloadDocumentsResponse.data;
        const convertedPdfList = await this.renderPdfList(
          this.originalDocumentsList
        );

        for (var pdf of convertedPdfList) {
          this.signedList.push({
            documentId: pdf.documentId,
            signed: pdf.convertedPdf,
          });
        }
        if (response.status === 200) {
          this.documentList = [];
          //Pushing documents based on their order
          for (var d of response.data) {
            if (d.order != 0) this.documentList[d.order - 1] = d;
            else this.documentList.push(d);
          }
          //if document doesn't have order (in case transaction was edited and there is no template for document) avoiding order placements
          if (this.documentList.includes(undefined))
            this.documentList = response.data;

          for (let i = 0; i < this.documentList.length; i++) {
            this.documentList[
              i
            ].convertedFile = this.originalDocumentsList.find(
              (f) => f.documentId === this.documentList[i].id
            ).fileContent.fileContents;
            const elems = [];
            this.documentList[i].template.roles.forEach((role) =>
              elems.push(...role.elements)
            );
            this.elementsList.push({
              documentId: this.documentList[i].id,
              elements: elems,
            });
            this.signedPdfList.push({
              documentId: this.documentList[i].id,
              pdf: null,
            });
          }

          this.currentDocument = this.documentList[0].id;
          this.file = this.documentList[0].convertedFile;
          this.activeDocument = this.documentList[0];
          this.fileName = this.documentList[0].originalName;
          this.activeDocument.template.roles.forEach((role) =>
            this.elements.push(...role.elements)
          );
          await this.getSignedPlacements(token);
          this.signedPdf = await this.generateSignedPdf();
          this.nextButtonMarginTop = this.documentList.length * 4;
        }
      } catch (error) {
        this.file = '';
        this.isLoading = false;
        let errorMessage = error;
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          if (error.response.data.message) {
            errorMessage = error.response.data.message;
          }
        }
        this.isError = true;
        this.message = errorMessage;
      }
    },

    async getSignedPlacements(token) {
      try {
        const data = { Token: token };
        const response = await this.$api.post(
          `sign-pdf/envelopes/get-signed-placements`,
          data
        );
        if (response.status === 200) {
          this.signedPlacements = response.data;
        }
      } catch (error) {
        this.file = '';
        this.isLoading = false;
        let errorMessage = error;
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          if (error.response.data.message) {
            errorMessage = error.response.data.message;
          }
        }
        this.isError = true;
        this.message = errorMessage;
      }
    },

    async submitEnvelopePlacements() {
      try {
        //Submit expense
        const roleOrderAssociate = 0;
        if(this.moduleId === this.moduleIdExpense && this.roleOrder == roleOrderAssociate && !this.createdByManagerId)
        {
          const resExpense = await this.submitExpense();
          if(!resExpense)
          {
            Bus.$emit('alert', 'warning', resExpense.data.message);
            return false;
          }
        }
        //Submit expense
        //Submit po
        else if(this.moduleId === this.moduleIdPO && this.roleOrder == roleOrderAssociate)
        {
          const resExpense = await this.submitPo();
          if(!resExpense)
          {
            Bus.$emit('alert', 'warning', resExpense.data.message);
            return false;
          }
        }
        //Submit po
        

        var placements = [];
        this.elementsList.forEach((el) => {
          el.elements.forEach((element) => {
            element.placements.forEach((p) => {
              var placement = {};
              placement.elementPlacementId = p.id;
              placement.documentId = el.documentId;
              placement.xPosition = p.xPosition;
              placement.yPosition = p.yPosition;
              placement.page = p.page;
              if (p.val_decimal) placement.valDecimal = p.val_decimal;
              if (p.val_date) placement.valDate = p.val_date;
              if (p.val_text) placement.valText = p.val_text;
              //if (p.val_blob) placement.valBlob = Array.from(p.val_blob);
              placement.valBlob = p.val_blob ? Array.from(p.val_blob) : [];
              if (p.val_uuid) placement.valUuid = p.val_uuid;

              placements.push(placement);
            });
          });
        });
        var data = { Token: this.token, Placements: placements };
        const res = await this.$api.post(
          `sign-pdf/envelopes/create-envelope-placements`,
          data
        );
        if (res.status != 200) Bus.$emit('alert', 'warning', res.statusText);

        for(let i = 0; i < this.documentList.length; i++)
        {
          //render all pdf files
          this.changeCurrentDocument(this.documentList[i])
          //
        }

        return res.data;
      } catch (error) {
        this.file = '';
        this.isLoading = false;

        let errorMessage = error;
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          if (error.response.data.message) {
            errorMessage = error.response.data.message;
          }
        }

        this.isError = true;
        this.message = errorMessage;
      }
    },

    async submitExpense()
    {
      const data = { token: this.token, itemId: this.moduleRecordId, workerId: this.signedByWorkerId };
      const res = await this.$api.post(
        `sign-pdf/envelopes/submit-expense`,
        data
      );

      return res;
    },

    async submitPo()
    {
      const data = { token: this.token, itemId: this.moduleRecordId, workerId: this.signedByWorkerId };
      const res = await this.$api.post(
        `sign-pdf/envelopes/submit-po`,
        data
      );

      return res;
    },

    async changeCurrentDocument(document) {
      this.activeDocument = document;
      this.file = document.convertedFile;

      this.currentDocument = document.id;
      this.elements = [];
      this.activeDocument.template.roles.forEach((role) =>
        this.elements.push(...role.elements)
      );

      const currentSigned = this.signedList.find(
        (s) => s.documentId === document.id
      );
      if (currentSigned !== null) this.signed = currentSigned.signed;
      this.page = 1;
      this.signedPdf = await this.generateSignedPdf();
    },
    async downloadCompanyLogo(token) {
      try {
        this.$api.setSxEnvironment(this.environment);

        const data = { Token: token };
        const res = await this.$api.post(
          `sign-pdf/envelopes/download/company-logo`,
          data
        );
        this.isLoading = false;
        if (res.status === 200) {
          //set company logo
          var companyLogo = res.data.result;

          if (companyLogo) {
            this.companyLogo =
              'data:' + companyLogo.mimeType + ';base64,' + companyLogo.file;
          }
          this.isError = false;
        }
      } catch (error) {
        this.companyLogo = '';
        this.isLoading = false;

        let errorMessage = error;
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          if (error.response.data.message) {
            errorMessage = error.response.data.message;
          }
        }

        this.isError = true;
        this.message = errorMessage;
      }
    },

    async getDocumentData(token) {
      try {
        this.$api.setSxEnvironment(this.environment);

        const data = { Token: token };
        const res = await this.$api.post(
          `sign-pdf/envelopes/document-data`,
          data
        );
        this.isLoading = false;
        if (res.status === 200) {
          try {
            if(res.data.pdfInfo)
            {
              this.pdfInfo = JSON.parse(res.data.pdfInfo || [])
              .reduce(this.parsePdfInfo, [])
              .map(({ value }) => value);
            }
          } catch (e) {
            console.error('Error parsing pdf info ' + e);
          }
          try
          {
            this.$nextTick(() => {
              this.elements.forEach((e) => {
                e.placements.forEach((p) => {
                  if (p.replaceText != null) {
                    p.text = this.pdfInfo.find(
                      ({ data }) => data === p.replaceText
                    );
                    p.page = p.text.page;
                    p.xPosition = p.text.left;
                    p.yPosition = p.text.top;
                  }
                });
              });
            });
          }
          catch(e)
          {
            console.error(e);
          }
          
          //set file to array buffer
          this.documentName =
            res.data.name !== null ? res.data.name : res.data.transactionName;
          this.signeeName = res.data.signedByName;
          this.fileName =
            res.data.fileName !== null
              ? res.data.fileName
              : res.data.transactionName;
          this.company.name = res.data.companyName;
          this.company.email = res.data.companyEmail;
          this.signeeOrderType = res.data.signeeOrderType;
          this.moduleId = res.data.moduleId;
          this.moduleRecordId = res.data.moduleRecordId;
          this.signedByName = res.data.signedByName;
          this.signedByWorkerId = res.data.signedByWorkerId;
          this.createdByManagerId = res.data.createdByManagerId;
          this.roleOrder = res.data.roleOrder;
          this.isError = false;

          return true;
        }
      } catch (error) {
        this.isLoading = false;

        let errorMessage = error;
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          if (error.response.data.message) {
            errorMessage = error.response.data.message;
          }
        }

        this.isError = true;
        this.message = errorMessage;

        return false;
      }
    },
    async getFonts() {
      try {
        this.$api.setSxEnvironment(this.environment);

        const res = await this.$api.get(`fonts`);
        this.isLoading = false;
        if (res.status === 200) {
          this.fonts = res.data;
          this.isError = false;
        }
      } catch (error) {
        this.isLoading = false;

        let errorMessage = error;
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          if (error.response.data.message) {
            errorMessage = error.response.data.message;
          }
        }

        this.isError = true;
        this.message = errorMessage;
      }
    },
    getPdfData() {
      return this.file;
    },

    async getWorkerSignature(token, isSubmit = true, isConfirm = true, isSignAll = false)
    {
      const data = { Token: token };
      const res = await this.$api.post(
          `sign-pdf/envelopes/get-worker-signature`,
          data
        );
      if(res.status !== 200 || !res.data || res.data.signatureBlob == null)
      {
        this.$refs.createPersonalSignatureForm.open();
        return;
      }

      this.signatureBlob = res.data.signatureBlob;
      this.initialBlob = res.data.initialBlob;

      if(res.data.isAutosignPrompt == 0 && !isSignAll) {
        this.isUsePermanetSignature = true;
        return;
      }

      if(isConfirm)
      {
        this.isUsePermanetSignature = await this.$refs.personalSignatureForm.open(res.data.signatureBlob, this.roleOrder != 0);
        return;
      }

      //Replace Signature
      if(res.data.signatureBlob != null)
      {
          this.replaceSignature('SignPdf_Signature', res);
          this.replaceSignature('SignPdf_Signature2', res);
          this.replaceSignature('SignPdf_Signature3', res);
          this.handleNext();
      }
      //Replace Signature

      //Replace Initials
      if(res.data.initialBlob != null)
      {
        this.replaceInititals('SignPdf_Initials', res);
      }
      //Replace Initials

      //Replace Name
      if(res.data.name != null)
      {
        this.replaceName('SignPdf_Acceptedby', res);
        this.replaceName('SignPdf_ManagerName1', res);
        this.replaceName('SignPdf_ManagerName2', res);
        this.replacePosition('SignPdf_ManagerPosition1', res);
        this.replacePosition('SignPdf_ManagerPosition2', res);
      }
      //Replace Name

      //Replace Name
      //Replace Name

      //Replace Date
      this.replaceDate('SignPdf_Date');
      this.replaceDate('SignPdf_ManagerDate1');
      this.replaceDate('SignPdf_ManagerDate2');
      this.replaceDate('SignPdf_AssociateDate');
      //Replace Date

      this.signedPdf = await this.generateSignedPdf();
      this.signedList.forEach((s) => {
        if (s.documentId === this.currentDocument) s.signed = this.signed;
      });
      this.elementsList.forEach((el) => {
        if (el.documentId === this.currentDocument) el.elements = this.elements;
      });

      this.finishButtonDisabled = this.countPlacementKeys();
      if(isSubmit) this.$refs.signPDFHeader.handleUpload(false);
    },

    replaceSignature(elementName, res)
    {
      const elementIndexes = this.getReplaceTextElementIndex(elementName);
      if(elementIndexes.elementIndex !== -1 && elementIndexes.placementIndex !== -1)
      {
        if (!this.signed[elementIndexes.elementIndex]) this.signed[elementIndexes.elementIndex] = [];
        this.signed[elementIndexes.elementIndex][elementIndexes.placementIndex] = {
          signature: `data:image/png;base64,${res.data.signatureBlob}`,
          isInitials: false
        };
      }
    },

    replaceInititals(elementName, res)
    {
      const elementIndexes = this.getReplaceTextElementIndex(elementName);

        if(elementIndexes.elementIndex !== -1 && elementIndexes.placementIndex !== -1)
        {
          if (!this.signed[elementIndexes.elementIndex]) this.signed[elementIndexes.elementIndex] = [];
          this.signed[elementIndexes.elementIndex][elementIndexes.placementIndex] = {
            signature: `data:image/png;base64,${res.data.initialBlob}`,
            isInitials: true
          };
        }
    },

    replaceName(elementName, res)
    {
      const elementIndexes = this.getReplaceTextElementIndex(elementName);

        if(elementIndexes.elementIndex !== -1 && elementIndexes.placementIndex !== -1)
        {
          if (!this.signed[elementIndexes.elementIndex]) this.signed[elementIndexes.elementIndex] = [];
          this.signed[elementIndexes.elementIndex][elementIndexes.placementIndex] = {
            text: res.data.name
          };
        }
    },

    replacePosition(elementName, res)
    {
      const elementIndexes = this.getReplaceTextElementIndex(elementName);

        if(elementIndexes.elementIndex !== -1 && elementIndexes.placementIndex !== -1)
        {
          if (!this.signed[elementIndexes.elementIndex]) this.signed[elementIndexes.elementIndex] = [];
          this.signed[elementIndexes.elementIndex][elementIndexes.placementIndex] = {
            text: res.data.title ? res.data.title : ''
          };
        }
    },

    replaceDate(elementName)
    {
      const elementIndexes = this.getReplaceTextElementIndex(elementName);

        if(elementIndexes.elementIndex !== -1 && elementIndexes.placementIndex !== -1)
        {
          const today = new Date();
          const year = today.getFullYear();
          const month = today.toLocaleString('default', { month: 'short' });
          const day = String(today.getDate()).padStart(2, '0');
          const formattedDate = `${year} ${month} ${day}`;

          if (!this.signed[elementIndexes.elementIndex]) this.signed[elementIndexes.elementIndex] = [];
          this.signed[elementIndexes.elementIndex][elementIndexes.placementIndex] = {
            text: formattedDate
          };
        }
    },

    getReplaceTextElementIndex(replaceText) {
      const returnData = {
        elementIndex: -1,
        placementIndex: -1
      };
      this.elements.forEach((element, elementIndex) => {
        if(element.hasOwnProperty('replaceText'))
        {
            element.placements.forEach((placement, placementIndex) => {
            if (placement.replaceText === replaceText) {
              returnData.elementIndex = elementIndex;
              returnData.placementIndex = placementIndex;
              return;
            }
          });
        }
      });

      return returnData;
    },

    async handleNext() {
      if (this.signed) {
        //Looking for unsigned placements. Checking signed array if element and plcements are in.
        var unsignedPlacements = [];
        this.elements.forEach((element, i) => {
          unsignedPlacements.push(
            ...element.placements.filter((p, pIdx) => {
              if (!this.signed[i]) return true;
              else if (!this.signed[i][pIdx]) return true;
            })
          );
        });

        unsignedPlacements.sort(this.compare);
        if (unsignedPlacements.length > 0) {
          const nextElement = unsignedPlacements[0];
          const nextElementIsLastPage = nextElement.isLastPage;
          const nextElementPage = nextElement.page;
          const nextElementYPosition = nextElement.yPosition;
          if (nextElementIsLastPage) {
            this.page = this.pagesCount;
          } else if (this.page != nextElementPage) {
            this.page = nextElementPage;
          }
          this.$nextTick(() => {
            const overlay = this.$refs.overlay;
            this.$refs.contentWrapper.scrollTop =
              overlay.height * nextElementYPosition - 200;
          });
        } else if (unsignedPlacements.length === 0) {
          const nextDocumentIndex = this.documentList.findIndex(
            (d) => d.id === this.activeDocument.id
          );
          if (nextDocumentIndex + 1 < this.documentList.length) {
            this.changeCurrentDocument(
              this.documentList[nextDocumentIndex + 1]
            );
            this.$refs.contentWrapper.scrollTop = 0;
            this.handleNext();
          }
        }
      } else {
        return false;
      }
    },
    compare(a, b) {
      const pageA = a.page;
      const pageB = b.page;
      const yPositionA = a.yPosition;
      const yPositionB = b.yPosition;
      const xPositionA = a.xPosition;
      const xPositionB = b.xPosition;

      const isLastPageA = a.isLastPage;
      const isLastPageB = b.isLastPage;

      let comparison = 0;
      //compare last page and pages
      if (isLastPageA > isLastPageB) {
        comparison = 1;
      } else if (isLastPageA < isLastPageB) {
        comparison = -1;
      } else if (pageA > pageB) {
        comparison = 1;
      } else if (pageA < pageB) {
        comparison = -1;
      }
      //compare y positions
      if (comparison == 0) {
        if (yPositionA > yPositionB) {
          comparison = 1;
        } else if (yPositionA < yPositionB) {
          comparison = -1;
        }
      }
      // compare x positions
      if (comparison == 0) {
        if (xPositionA > xPositionB) {
          comparison = 1;
        } else if (xPositionA < xPositionB) {
          comparison = -1;
        }
      }
      return comparison;
    },

    handleSignDrawing() {
      this.showSignaturePad = true;

      //Remember signature pad choice
      if(this.isInitials)
      {
        this.signaturePadState[this.signaturePadStateIdInitials] = true;
      }
      else
      {
        this.signaturePadState[this.signaturePadStateIdSignature] = true;
      }
      //
      this.$nextTick(() => {
        const canvas = this.$refs.signature;
        if (!canvas) {
          return;
        }
        this.signaturePad = new SignaturePad(canvas);
      });
    },
    async handleSignDrawingSubmit() {
      if (!this.signed[this.signingElement]) this.signed[this.signingElement] = [];

      this.signed[this.signingElement][this.signingPlacement] = {
        signature: this.signaturePad.toDataURL(),
        isInitials: this.isInitials
      };
      this.signedPdf = await this.generateSignedPdf();
      this.showSignaturePad = false;
    },
    async handleSignTyping() {
      let nameSignature = prompt(
        this.isInitials ? 'Please enter your name as initials' : 'Please enter your name as signature',
        this.getLastElementName()
      )
      if (!nameSignature) {this.showSignatureModal = true; return;}

      //Remember signature pad choice
      if(this.isInitials)
      {
        this.signaturePadState[this.signaturePadStateIdInitials] = false;
      }
      else
      {
        this.signaturePadState[this.signaturePadStateIdSignature] = false;
      }
      //

      nameSignature = this.isInitials ? nameSignature.toUpperCase() : nameSignature
      if (!this.signed[this.signingElement])
        this.signed[this.signingElement] = [];
      this.elements[this.signingElement].placements[
        this.signingPlacement
      ].val_text = nameSignature;
      this.signed[this.signingElement][this.signingPlacement] = {
        nameSignature: await this.textToImage(nameSignature),
        text: nameSignature,
        isInitials: this.isInitials
      };
      this.setLastElemenName(nameSignature)

      this.signedPdf = await this.generateSignedPdf();
    },
    async textToImage(nameText) {
      var canvas = document.createElement('canvas');
      canvas.width = 1000;
      canvas.height = 110;
      var ctx = canvas.getContext('2d');
      ctx.font = `80px ${this.betterFont}`;
      ctx.fillText(nameText, 1, 100);
      var nameSignatureImage = canvas.toDataURL();
      return nameSignatureImage;
    },
    async handleSignDate() {
      if (!this.signed[this.signingElement])
        this.signed[this.signingElement] = [];
      this.signed[this.signingElement][this.signingPlacement] = {
        date: this.signingDate,
      };
      this.signedPdf = await this.generateSignedPdf();
    },
    async handleSignText() {
      const text = prompt(
        `Please type the ${this.elements[this.signingElement].label}`,
         this.getLastElementName()
      );
      if (!text) return;
      if (!this.signed[this.signingElement])
        this.signed[this.signingElement] = [];
      this.signed[this.signingElement][this.signingPlacement] = { text };
      this.setLastElemenName(text)
      this.signedPdf = await this.generateSignedPdf();
    },
    async handleSignCurrency() {
      const currency = prompt(
        `Please type the ${
          this.elements[this.signingElement].label
        } (currency amount)`,
        this.getLastElementName()
      );
      if (!currency) return;
      if (!this.signed[this.signingElement])
        this.signed[this.signingElement] = [];
      this.signed[this.signingElement][this.signingPlacement] = { currency };
      this.setLastElemenName(currency)
      this.signedPdf = await this.generateSignedPdf();
    },

    openSignatureDisclosure() {
      this.$refs.signatureDisclosureDialog.open();
    },


    getLastElementName(){

      const lastLabel = this.lastElementLabels.find(x => x.elementId === this.signingElement)
      if(!lastLabel) return ''
      return lastLabel.name
    },

    setLastElemenName(newLabel){
      
      const lastElementIndex = this.lastElementLabels.findIndex(x => x.elementId === this.signingElement)
      if(lastElementIndex !== -1) this.lastElementLabels[lastElementIndex].name = newLabel
      else this.lastElementLabels.push({elementId: this.signingElement, name: newLabel})
    },

    async generateSignedPdf() {
      const getPdfDoc = await this.loadPdfDocument();
      const pdfDoc = getPdfDoc.pdfDoc;
      const dateFont = getPdfDoc.pdfDoc.dateFont;
      const pages = getPdfDoc.pages;
      const { width, height } = pages[0].getSize();

      await this.generatePdfSignedPlacements(
        pages,
        dateFont,
        pdfDoc,
        this.activeDocument.template.id
      );
      for (const idx of Object.keys(this.signed)) {
        const element = this.elements[idx];
        const elementFont = await this.getFont(element.fontId, pdfDoc);
        for (const placeIdx of Object.keys(element.placements)) {
          const placement = element.placements[placeIdx];
          var page;
          if (placement.isLastPage && placement.isLastPage == true) {
            page = pages[this.pagesCount - 1];
          } else {
            page = pages[placement.page - 1];
          }
          if (placement.text != null) {
            page.drawRectangle({
              x: placement.text.left * width,
              y:
                height -
                placement.text.top * height -
                placement.text.height * height,
              width: placement.text.width * width,
              height: placement.text.height * height,
              color: rgb(1, 1, 1),
              opacity: 1,
            });
          }

          if (
            this.signed[idx][placeIdx] &&
            'signature' in this.signed[idx][placeIdx]
          ) {
            const pngBytes = await fetch(
              this.signed[idx][placeIdx].signature
            ).then((res) => res.arrayBuffer());

            const pngImage = await pdfDoc.embedPng(pngBytes);
            const pngDims = pngImage.scale(element.fontSize / pngImage.height);

            const timeZoneAbbr = new Intl.DateTimeFormat([], { timeZoneName: 'short' })
                .formatToParts(new Date())
                .find(part => part.type === 'timeZoneName')
                .value;
                
            if(this.signed[idx][placeIdx].isInitials){
              const options = {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                hour12: true,
              };

              const today = new Date();
              const formattedDate = today.toLocaleString('en-US', options);
              const inititals = this.getInitials(this.signedByName);
              const signedBy = `${inititals}, ${formattedDate}`;
              page.drawText(signedBy, {
              x: placement.xPosition * width - 3.6,
              y:
                height -
                placement.yPosition * height -
                element.fontSize / 1.286 +
                pngDims.height,
              size: 5,
              font: dateFont,
            });
            }else{
              const options = {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                hour12: true,
              };

              const today = new Date();
              const formattedDate = today.toLocaleString('en-US', options);
              const signedBy = `Signed By: ${this.signedByName}, on: ${formattedDate} ${timeZoneAbbr}`
              page.drawText(signedBy, {
              x: placement.xPosition * width - 4,
              y:
                height -
                placement.yPosition * height -
                element.fontSize / 1.286 +
                pngDims.height,
              size: 5,
              font: dateFont,
            });
            }
            page.drawLine({
              start: { 
                x: placement.xPosition * width - 3,
                y: height -
                placement.yPosition * height -
                element.fontSize / 1.286 +
                pngDims.height - 1 },

              end: { 
                x: placement.xPosition * width - 3,
                y: height - placement.yPosition * height - pngDims.height + 4 },
              thickness: 0.4,
              color: rgb(0, 0, 0),
              opacity: 1,
            })
            page.drawImage(pngImage, {
              x: placement.xPosition * width,
              y:
                height - 2 -
                placement.yPosition * height -
                element.fontSize / 1.286,
              width: pngDims.width,
              height: pngDims.height,
            });
            const uuid = this.getUUID();
            if(this.signed[idx][placeIdx].isInitials){
              page.drawText(`${uuid.substring(0, 15)}...`, {
              x: placement.xPosition * width - 4,
              y: height - placement.yPosition * height - pngDims.height,
              size: 5,
              font: dateFont,
            });
            }
            else
            {
              page.drawText(`Digital Signature: ${uuid.substring(0, 15)}...`, {
              x: placement.xPosition * width - 4,
              y: height - placement.yPosition * height - pngDims.height,
              size: 5,
              font: dateFont,
            });
            }
            
            this.elements[idx].placements[placeIdx].val_blob = new Uint8Array(
              pngBytes
            );
            if (this.elements[idx].placements[placeIdx].val_text)
              this.elements[idx].placements[placeIdx].val_text = null;
            this.elements[idx].placements[placeIdx].val_uuid = uuid;

          } else if (
            this.signed[idx][placeIdx] &&
            'nameSignature' in this.signed[idx][placeIdx]
          ) {

            const pngBytes = await fetch(
              this.signed[idx][placeIdx].nameSignature
            ).then((res) => res.arrayBuffer());

            const pngImage = await pdfDoc.embedPng(pngBytes);
            const pngDims = pngImage.scale(element.fontSize / pngImage.height);
            const timeZoneAbbr = new Intl.DateTimeFormat([], { timeZoneName: 'short' })
                .formatToParts(new Date())
                .find(part => part.type === 'timeZoneName')
                .value;

            if(this.signed[idx][placeIdx].isInitials){
              const options = {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                hour12: true,
              };

              const today = new Date();
              const formattedDate = today.toLocaleString('en-US', options);
              const inititals = this.getInitials(this.signedByName);
              const signedBy = `${inititals}, ${formattedDate}`;
              
              page.drawText(signedBy, {
              x: placement.xPosition * width - 3.5,
              y:
                height -
                placement.yPosition * height -
                element.fontSize / 1.286 +
                pngDims.height,
              size: 5,
              font: dateFont,
            });
            }
            else{
              
              const options = {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                hour12: true,
              };

              const today = new Date();
              const formattedDate = today.toLocaleString('en-US', options);

              const signedBy = `Signed By: ${this.signedByName}, on: ${formattedDate} ${timeZoneAbbr}`
              page.drawText(signedBy, {
              x: placement.xPosition * width - 4,
              y:
                height -
                placement.yPosition * height -
                element.fontSize / 1.286 +
                pngDims.height,
              size: 5,
              font: dateFont,
            });
            }
            page.drawLine({
              start: { 
                x: placement.xPosition * width - 3,
                y: height -
                placement.yPosition * height -
                element.fontSize / 1.286 +
                pngDims.height - 1 },

              end: { 
                x: placement.xPosition * width - 3,
                y: height - placement.yPosition * height - pngDims.height + 4 },
              thickness: 0.4,
              color: rgb(0, 0, 0),
              opacity: 1,
            })
            page.drawImage(pngImage, {
              x: placement.xPosition * width,
              y:
                height + 2 -
                placement.yPosition * height -
                element.fontSize / 1.286,
              width: pngDims.width,
              height: pngDims.height,
            });

            const uuid = this.getUUID();
            if(this.signed[idx][placeIdx].isInitials){
              page.drawText(`${uuid.substring(0, 15)}...`, {
              x: placement.xPosition * width - 4,
              y:
                height -
                placement.yPosition * height - pngDims.height,
              size: 5,
              font: dateFont,
            });
            }
            else
            {
              page.drawText(`Digital Signature: ${uuid.substring(0, 15)}...`, {
                x: placement.xPosition * width - 4,
                y:
                  height -
                  placement.yPosition * height - pngDims.height,
                size: 5,
                font: dateFont,
              });
            }
            this.elements[idx].placements[placeIdx].val_blob = new Uint8Array(
              pngBytes
            );
            this.elements[idx].placements[placeIdx].val_text = this.signed[idx][
              placeIdx
            ].text;
            this.elements[idx].placements[placeIdx].val_uuid = uuid;
          } else if (
            this.signed[idx][placeIdx] &&
            'date' in this.signed[idx][placeIdx]
          ) {
            page.drawText(
              dayjs(this.signed[idx][placeIdx].date).format('YYYY MMM DD'),
              {
                x: placement.xPosition * width,
                y: height - placement.yPosition * height - element.fontSize / 2,
                size: element.fontSize / 2,
                font: elementFont,
              }
            );
            this.elements[idx].placements[placeIdx].val_date = this.signed[idx][
              placeIdx
            ].date;
          } else if (
            this.signed[idx][placeIdx] &&
            'text' in this.signed[idx][placeIdx]
          ) {
            page.drawText(this.signed[idx][placeIdx].text, {
              x: placement.xPosition * width,
              y: height - placement.yPosition * height - element.fontSize / 2,
              size: element.fontSize / 2,
              font: elementFont,
            });
            this.elements[idx].placements[placeIdx].val_text = this.signed[idx][
              placeIdx
            ].text;
          } else if (
            this.signed[idx][placeIdx] &&
            'currency' in this.signed[idx][placeIdx]
          ) {
            page.drawText('$' + this.signed[idx][placeIdx].currency, {
              x: placement.xPosition * width,
              y: height - placement.yPosition * height - element.fontSize / 2,
              size: element.fontSize / 2,
              font: elementFont,
            });
            this.elements[idx].placements[placeIdx].val_decimal = this.signed[
              idx
            ][placeIdx].currency;
          }
        }
      }

      this.signingElement = -1;
      this.signingPlacement = -1;
      return await pdfDoc.save();
    },

    async generatePdfSignedPlacements(
      pages,
      dateFont,
      pdfDoc,
      templateId = null,
      isSignedPlaces = 0
    ) {
      const { width, height } = pages[0].getSize();
      for (let p of this.signedPlacements) {
        if (templateId && p.templateId === templateId) {
          const placementFont = await this.getFont(p.fontId, pdfDoc);
          var page;
          if (p.isLastPage && p.isLastPage == true) {
            page = pages[this.pagesCount - 1];
          } else {
            page = pages[p.page - 1];
          }
          if (p.valBlob && p.valBlob !== null && p.valBlob !== '') {
            const pngBytes = await (
              await fetch(`data:image/png;base64,${p.valBlob}`).then((res) =>
                res.blob()
              )
            ).arrayBuffer();
            const pngImage = await pdfDoc.embedPng(pngBytes);
            const pngDims = pngImage.scale(p.fontSize / pngImage.height);
            const timeZoneAbbr = new Intl.DateTimeFormat([], { timeZoneName: 'short' })
                .formatToParts(new Date())
                .find(part => part.type === 'timeZoneName')
                .value;

            if(p.elementTypeId === 5){
              const options = {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: 'numeric', 
                minute: 'numeric',
                hour12: true,
              };

              const formattedDate = p.createdAt.toLocaleString('en-US', options);
              const inititals = this.getInitials(p.signedByName);
              const signedBy = `${inititals}, ${formattedDate}`;
              page.drawText(signedBy, {
              x: p.xPosition * width - 3.6,
              y: height - p.yPosition * height - p.fontSize / 1.286 + 26,
              size: 5,
              font: dateFont,
            });
            }
            else{

              const signedBy = `Signed By: ${p.signedByName ?p.signedByName : '' }, on: ${p.createdAt} ${timeZoneAbbr}`
              page.drawText(signedBy, {
              x: p.xPosition * width - 3.6,
              y: height - p.yPosition * height - p.fontSize / 1.286 + 26,
              size: 5,
              font: dateFont,
            });
            }
            page.drawLine({
              start: { 
                x: p.xPosition * width - 3,
                y: height -
                p.yPosition * height -
                p.fontSize / 1.286 +
                25 },

              end: { 
                x: p.xPosition * width - 3,
                y: height - p.yPosition * height - p.fontSize + 4 },
              thickness: 0.4,
              color: rgb(0, 0, 0),
              opacity: 1,
            })
            page.drawImage(pngImage, {
              x: p.xPosition * width,
              y: height - 4 - p.yPosition * height - p.fontSize / 1.286,
              width: pngDims.width,
              height: pngDims.height,
            });
            if(p.elementTypeId === 5)
            {
              page.drawText(`${p.valUuid}...`, {
              x: p.xPosition * width - 4,
              y: height - p.yPosition * height - p.fontSize / 1.286 - 7,
              size: 5,
              font: dateFont,
            });
            }
            else
            {
              page.drawText(`Digital Signature: ${p.valUuid}...`, {
              x: p.xPosition * width - 4,
              y: height - p.yPosition * height - p.fontSize / 1.286 - 7,
              size: 5,
              font: dateFont,
            });
            }
            
          } else if (p.valText && p.valText !== null) {
            page.drawText(p.valText, {
              x: p.xPosition * width,
              y: height - p.yPosition * height - p.fontSize / 2,
              size: p.fontSize / 2,
              font: placementFont,
            });
          } else if (p.valDate && p.valDate !== null) {
            page.drawText(dayjs(p.valDate).format('YYYY MMM DD'), {
              x: p.xPosition * width,
              y: height - p.yPosition * height - p.fontSize / 2,
              size: p.fontSize / 2,
              font: placementFont,
            });
          } else if (p.valDecimal && p.valDecimal !== null) {
            page.drawText('$' + p.valDecimal, {
              x: p.xPosition * width,
              y: height - p.yPosition * height - p.fontSize / 2,
              size: p.fontSize / 2,
              font: placementFont,
            });
          }
        }
      }
      if (isSignedPlaces === 1) return await pdfDoc.save();
    },

    async handleDownload() {
      const zipName = this.documentName;
      var zip = new JSZip();

      var convertedPdfList = await this.renderPdfList(
        this.originalDocumentsList
      );
      if (convertedPdfList.length === 1) {
        const pdfName = this.documentList.find(
          (d) => d.id === convertedPdfList[0].documentId
        ).originalName;
        saveAs(convertedPdfList[0].convertedPdf, `${pdfName}.pdf`);
      } else {
        for (var pdf of convertedPdfList) {
          const pdfName = this.documentList.find((d) => d.id === pdf.documentId)
            .originalName;
          zip.file(`${pdfName}.pdf`, pdf.convertedPdf, { binary: true });
        }
        zip.generateAsync({ type: 'blob' }).then(function (content) {
          saveAs(content, `${zipName}.OriginalDocuments.zip`);
        });
      }
    },

    getUUID() {
      return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0,
          v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16).toUpperCase();
      });
    },

    redirectProfileLink() {
      const serverPrefix = process.env.VUE_APP_SERVER_PREFIX
      const serverAddress = process.env.VUE_APP_SERVER_ADDRESS
      return `${serverPrefix}${this.environment}.${serverAddress}/workers/my_account`
    },

    redirect(moduleId)
    {
      let module = '';

      if(moduleId == this.moduleIdExpense)
      {
        module = 'expenses'
      }
      else if(moduleId == this.moduleIdTimesheet)
      {
        module = 'timeattendances'
      }
      else if(moduleId == this.moduleIdPO)
      {
        module = 'purchase_orders'
      }

      let serverPrefix = process.env.VUE_APP_SERVER_PREFIX;
      let serverAddress =  process.env.VUE_APP_SERVER_ADDRESS;

      window.location.replace(
        `${serverPrefix}${this.environment}.${serverAddress}/${module}`
      );
    },

    getModuleName()
    {
      let module = 'Sign Pdf';

      if(this.moduleId == this.moduleIdExpense)
      {
        module = 'Expenses'
      }
      else if(this.moduleId == this.moduleIdTimesheet)
      {
        module = 'Time Sheets'
      }
      else if(this.moduleId == this.moduleIdPO)
      {
        module = 'Purchase Orders'
      }
      return module;
    },
    
    mousemove(e) {
      this.mouse.x =
        Math.round((this.getX(e) / this.$refs.canvas.offsetWidth) * 1000) /
        1000;
      this.mouse.y =
        Math.round((this.getY(e) / this.$refs.canvas.offsetHeight) * 1000) /
        1000;

      const cursorPlacememnt = this.elements.find((element) => {
        const elementPlacement = element.placements.find((placement) => {
          const label = placement.val_date
            ? placement.val_date
            : placement.val_text
            ? placement.val_text
            : placement.val_decimal
            ? placement.val_decimal
            : null;

          return (
            placement.page == this.page &&
            this.mouse.y >= placement.yPosition &&
            this.mouse.y <=
              placement.yPosition +
                (placement.val_blob ? 0.03 : element.fontSize / 1000) &&
            this.mouse.x >= placement.xPosition &&
            this.mouse.x <=
              placement.xPosition +
                (placement.val_blob && placement.val_text
                  ? this.getBoxWidth(
                      placement.val_text,
                      element.fontSize,
                      this.$refs.overlay
                    ) * 0.5
                  : label != null
                  ? this.getBoxWidth(
                      label,
                      element.fontSize,
                      this.$refs.overlay
                    )
                  : placement.val_blob
                  ? 150
                  : this.getBoxWidth(
                      element.label,
                      element.fontSize,
                      this.$refs.overlay
                    )) /
                  1000
          );
        });
        if (elementPlacement) return true;
      });
      cursorPlacememnt
        ? (document.body.style.cursor = 'pointer')
        : (document.body.style.cursor = 'default');

      if (this.placing != null) this.renderOverlay();
    },
    handleCanvasElementClick() {
      const copiedElements = JSON.parse(JSON.stringify(this.elements));
      const foundElement = copiedElements.find((element) => {
        const elementPlacements = element.placements.find((placement) => {
          const label = placement.val_date
            ? placement.val_date
            : placement.val_text
            ? placement.val_text
            : placement.val_decimal
            ? placement.val_decimal
            : null;

          return (
            placement.page == this.page &&
            this.mouse.y >= placement.yPosition &&
            this.mouse.y <=
              placement.yPosition +
                (placement.val_blob ? 0.03 : element.fontSize / 1000) &&
            this.mouse.x >= placement.xPosition &&
            this.mouse.x <=
              placement.xPosition +
                (placement.val_blob && placement.val_text
                  ? this.getBoxWidth(
                      placement.val_text,
                      element.fontSize,
                      this.$refs.overlay
                    ) * 0.5
                  : label != null
                  ? this.getBoxWidth(
                      label,
                      element.fontSize,
                      this.$refs.overlay
                    )
                  : placement.val_blob
                  ? 150
                  : this.getBoxWidth(
                      element.label,
                      element.fontSize,
                      this.$refs.overlay
                    )) /
                  1000
          );
        });

        if (elementPlacements) {
          element.placements = elementPlacements;
          return true;
        }
        return false;
      });

      if (foundElement) return foundElement;
    },
    async handleOverlayClick() {
      const foundElement = this.handleCanvasElementClick();
      if (foundElement == null) return;

      const elementIndex = this.elements.findIndex(
        (element) => element.id === foundElement.id
      );
      const placementIndex = this.elements[elementIndex].placements.findIndex(
        (placement) =>
          placement.xPosition == foundElement.placements.xPosition &&
          placement.yPosition == foundElement.placements.yPosition &&
          placement.page == foundElement.placements.page
      );

      this.signingElement = elementIndex;
      this.signingPlacement = placementIndex;
      this.isInitials = false

      switch (foundElement.elementTypeId) {
        case 1:
          //signature
          if(this.signaturePadState[this.signaturePadStateIdSignature] === true)
          {
            this.handleSignDrawing();
          }
          else if(this.signaturePadState[this.signaturePadStateIdSignature] === false)
          {
            this.handleSignTyping();
          }
          else
          {
            if (this.isUsePermanetSignature && (this.signatureBlob && (!this.elements[this.signingElement] || !this.elements[this.signingElement].placements[this.signingPlacement] || !this.elements[this.signingElement].placements[this.signingPlacement].val_blob)))
            {
              if (!this.signed[this.signingElement]) this.signed[this.signingElement] = [];
              this.signed[this.signingElement][this.signingPlacement] = {
                signature: `data:image/png;base64,${this.signatureBlob}`,
                isInitials: false
              };
               this.signedPdf = await this.generateSignedPdf();
                this.signedList.forEach((s) => {
                  if (s.documentId === this.currentDocument) s.signed = this.signed;
                });
                this.elementsList.forEach((el) => {
                  if (el.documentId === this.currentDocument) el.elements = this.elements;
                });

                this.finishButtonDisabled = this.countPlacementKeys();
            }
            else
            {
              this.showSignatureModal = true;
            }
          }
          
          break;
        case 2:
          //date
          this.showDateModal = true;
          break;
        case 3:
          //text
          this.handleSignText();
          break;
        case 4:
          //currency
          this.handleSignCurrency();
          break;
        case 5:
          //Initials
          this.isInitials = true
           if(this.signaturePadState[this.signaturePadStateIdInitials] === true)
          {
            this.handleSignDrawing();
          }
          else if(this.signaturePadState[this.signaturePadStateIdInitials] === false)
          {
            this.handleSignTyping();
          }
          else
          {
            this.showSignatureModal = true;
          }
          break
      }
    },
    countPlacementKeys() {
      var signedKeysLength = 0;
      var elementsLength = 0;
      for (var s of this.signedList) {
        Object.keys(s.signed).forEach((key) => {
          signedKeysLength += key ? Object.keys(s.signed[key]).length : 0;
        });
      }
      this.elementsList.forEach((el) => {
        el.elements.forEach((elem) => {
          elementsLength += elem.placements.length;
        });
      });

      return signedKeysLength !== elementsLength;
    },

    getInitials(str) {
      if(!str) return '';
      const words = str.split(' ');
      let initials = words[0].charAt(0);
      if (words.length > 1) {
        initials += words[1].charAt(0);
      }
      return initials;
    }
  },
};
</script>

<style lang="scss">
@font-face {
  font-family: 'BetterGrade';
  src: url('/BetterGrade.ttf');
  font-size: 50px;
}
.clickable {
  cursor: pointer;
}
.placing {
  cursor: crosshair;
}

.container {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.content-pdf {
  border: 0px;
  flex-grow: 1;
  overflow-x: auto;
  background-color: #eae8ea;
}
.next-tag {
  // background-color: #f0f0f0;
  overflow: hidden;
  position: fixed; /* Set the navbar to fixed position */
  top: 100px; /* Position the navbar at the top of the page */
  left: 12%;
  // width: 100vw; /* Full width */
  z-index: 100;
}
html {
  margin: 0;
  padding: 0;
  overflow: hidden;
}
.action-bar {
  background-color: #f0f0f0 !important;
}
#fontLoader {
  font-family: 'BetterGrade';
}

</style>
